import { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import ObjetoCard from "./ObjetoCard";
import ImagenModal from "./ImagenModal";

import { doc, updateDoc } from "firebase/firestore";

const OBJETOS_POR_PAGINA = 9;

export default function BuscarObjetos({ usuario }) {
  const [objetos, setObjetos] = useState([]);
  const [filtroTexto, setFiltroTexto] = useState("");
  //const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("Todas");
  const [tipoSeleccionado, setTipoSeleccionado] = useState("todos");
  //const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);
  //const [objetoAResolver, setObjetoAResolver] = useState(null);
  const [mostrarResueltos, setMostrarResueltos] = useState(true);
  const [imagenModal, setImagenModal] = useState(null);
  const [paginaActual, setPaginaActual] = useState(1);

  const marcarComoResuelto = async (id) => {
    try {
      const ref = doc(db, "objetos", id);
      await updateDoc(ref, { resuelto: true });
      // Refrescar lista
      setObjetos((prev) =>
        prev.map((obj) => (obj.id === id ? { ...obj, resuelto: true } : obj))
      );
    } catch (error) {
      console.error("Error al marcar como resuelto:", error);
    }
  };

  useEffect(() => {
    const obtenerObjetos = async () => {
      const q = query(collection(db, "objetos"), orderBy("timestamp", "desc"));
      const querySnapshot = await getDocs(q);
      const datos = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setObjetos(datos);
    };
    obtenerObjetos();
  }, []);

  const filtrados = objetos.filter((obj) => {
    const coincideTexto =
      obj.descripcion.toLowerCase().includes(filtroTexto.toLowerCase()) ||
      obj.lugar.toLowerCase().includes(filtroTexto.toLowerCase());

    const coincideTipo =
      tipoSeleccionado === "todos" || obj.tipo === tipoSeleccionado;

    const coincideResuelto = mostrarResueltos || !obj.resuelto;

    return coincideTexto && coincideTipo && coincideResuelto;
  });

  const totalPaginas = Math.max(1, Math.ceil(filtrados.length / OBJETOS_POR_PAGINA));

  // Si cambian los filtros y la página actual queda fuera de rango, volvemos a la 1
  useEffect(() => {
    setPaginaActual(1);
  }, [filtroTexto, tipoSeleccionado, mostrarResueltos]);

  const inicio = (paginaActual - 1) * OBJETOS_POR_PAGINA;
  const paginados = filtrados.slice(inicio, inicio + OBJETOS_POR_PAGINA);

  const irAPagina = (n) => {
    const pagina = Math.min(Math.max(1, n), totalPaginas);
    setPaginaActual(pagina);
    document.getElementById("buscador")?.scrollIntoView({ behavior: "smooth" });
  };

  // Ventana de páginas visibles (evita listar decenas de botones en mobile)
  const paginasVisibles = (() => {
    const rango = 1; // páginas a cada lado de la actual
    const desde = Math.max(1, paginaActual - rango);
    const hasta = Math.min(totalPaginas, paginaActual + rango);
    const paginas = [];

    if (desde > 1) {
      paginas.push(1);
      if (desde > 2) paginas.push("...");
    }
    for (let i = desde; i <= hasta; i++) paginas.push(i);
    if (hasta < totalPaginas) {
      if (hasta < totalPaginas - 1) paginas.push("...");
      paginas.push(totalPaginas);
    }
    return paginas;
  })();

  return (
    <section id="buscador" name="buscador" className="bg-gray-100">
      <div className="max-w-6xl mx-auto p-4 py-32">
        <section className="space-y-2 pb-6">
          <h2 className="text-3xl font-bold tracking-tighter md:text-4xl/tight">
            Objetos perdidos
          </h2>
          <p className="max-w-[900px] text-muted-foreground md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed">
            Buscá entre los reportes existentes y contactate con quien lo
            publicó.
          </p>
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div className="md:flex gap-4">
              <div className="flex items-center gap-4">
                {/* <label className="font-medium">Tipo:</label> */}
                <label className="flex items-center gap-1 cursor-pointer">
                  <input
                    type="radio"
                    name="tipo"
                    value="todos"
                    checked={tipoSeleccionado === "todos"}
                    onChange={() => setTipoSeleccionado("todos")}
                  />
                  Todos
                </label>
                <label className="flex items-center gap-1 cursor-pointer">
                  <input
                    type="radio"
                    name="tipo"
                    value="perdido"
                    checked={tipoSeleccionado === "perdido"}
                    onChange={() => setTipoSeleccionado("perdido")}
                  />
                  Perdidos
                </label>
                <label className="flex items-center gap-1 cursor-pointer">
                  <input
                    type="radio"
                    name="tipo"
                    value="encontrado"
                    checked={tipoSeleccionado === "encontrado"}
                    onChange={() => setTipoSeleccionado("encontrado")}
                  />
                  Encontrados
                </label>
              </div>
              <div className="flex items-center gap-4">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={mostrarResueltos}
                    onChange={(e) => setMostrarResueltos(e.target.checked)}
                  />
                  Mostrar resueltos
                </label>
              </div>
            </div>
            <div className="relative w-full md:w-auto md:min-w-s flex flex-col md:flex-row gap-4 ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-search absolute left-2.5 top-3 h-4 w-4 text-muted-foreground"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.3-4.3"></path>
              </svg>
              <input
                type="search"
                placeholder="Buscar objeto..."
                className="flex-1 border px-3 py-2 pl-8 rounded bg-white"
                value={filtroTexto}
                onChange={(e) => setFiltroTexto(e.target.value)}
              />
            </div>
          </div>
          <p className="text-sm text-gray-500 pt-2">
            {filtrados.length === 0
              ? "No se encontraron objetos."
              : `Mostrando ${inicio + 1}-${Math.min(inicio + OBJETOS_POR_PAGINA, filtrados.length)} de ${filtrados.length} objeto${filtrados.length === 1 ? "" : "s"}`}
          </p>
        </section>

        <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {filtrados.length === 0 && (
            <p className="text-gray-500">No se encontraron objetos.</p>
          )}

          {paginados.map((obj) => (
            <ObjetoCard
              key={obj.id}
              obj={obj}
              usuario={usuario}
              onMarcarResuelto={marcarComoResuelto}
              onClickImagen={(url) => setImagenModal(url)}
            />
          ))}
        </div>

        {totalPaginas > 1 && (
          <div className="flex flex-wrap items-center justify-center gap-2 pt-10 px-2">
            <button
              onClick={() => irAPagina(paginaActual - 1)}
              disabled={paginaActual === 1}
              className="px-2.5 py-2 sm:px-3 rounded border bg-white disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-50 text-sm sm:text-base"
            >
              ‹ <span className="hidden sm:inline">Anterior</span>
            </button>

            {paginasVisibles.map((n, idx) =>
              n === "..." ? (
                <span
                  key={`ellipsis-${idx}`}
                  className="px-1 text-gray-400 select-none"
                >
                  …
                </span>
              ) : (
                <button
                  key={n}
                  onClick={() => irAPagina(n)}
                  className={`px-3 py-2 rounded border min-w-[36px] sm:min-w-[40px] text-sm sm:text-base ${
                    n === paginaActual
                      ? "bg-blue-600 text-white border-blue-600"
                      : "bg-white hover:bg-gray-50"
                  }`}
                >
                  {n}
                </button>
              )
            )}

            <button
              onClick={() => irAPagina(paginaActual + 1)}
              disabled={paginaActual === totalPaginas}
              className="px-2.5 py-2 sm:px-3 rounded border bg-white disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-50 text-sm sm:text-base"
            >
              <span className="hidden sm:inline">Siguiente</span> ›
            </button>
          </div>
        )}

        {imagenModal && (
          <ImagenModal
            imagenUrl={imagenModal}
            onCerrar={() => setImagenModal(null)}
          />
        )}
      </div>
    </section>
  );
}
